import React from 'react';

const SwaggerIcon: React.FC<{ style?: React.CSSProperties }> = ({ style }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 32 32"
    fill="none"
    style={style}
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="16" cy="16" r="16" fill="#222" />
    <ellipse cx="16" cy="16" rx="10" ry="4.5" fill="#85EA2D" />
    <ellipse cx="16" cy="16" rx="7.5" ry="2.5" fill="#222" />
    <circle cx="12.5" cy="16" r="1.5" fill="#85EA2D" />
    <circle cx="19.5" cy="16" r="1.5" fill="#85EA2D" />
  </svg>
);

export default SwaggerIcon; 